import $ from 'jquery';

/* eslint-enable */

export default () => {
  $(document).ready(function() {
 if($(".ocar-show-warning").length){let e=$(".ocar-show-warning .ocar-fee-box-container .ocar-month").closest(".ocar-fee-box-container"),a=e.find('[data-ocar-fee-header="Membership Fees"] > hr ~.ocar-row label');a.length&&(a.append('<span style="color: red;"> **</span>'),e.after('<span className="ocar-warning" style="color: red;">** If you have paid Realtor dues within the past 24 months, please contact us directly for a quote 949-586-6800</span>'))};
   $('.ocar-selected-month').click(function (e) {
      e.stopPropagation();
      $(this).parents('.ocar-months-container').find('.ocar-months').addClass('hover');
    });

    $('.ocar-months h3').click(function (e) {
      var $this = $(this);
      var $parent = $this.parents('.ocar-months-container');
      $parent.find('.ocar-selected-month').text($this.text());
      $parent.find('.ocar-months').removeClass('hover');
      $this.parents('#ocar-fees-container').find('.ocar-fee-box div[data-ocar-month="' + $this.attr("data-ocar-month") + '"]').addClass('ocar-show').siblings().removeClass('ocar-show');
      $('#ocar-fee-header').text($('#ocar-fee .ocar-show').attr('data-ocar-fee-header'));
      $('#ocar-key-header').text($('#ocar-key .ocar-show').attr('data-ocar-key-header'));
    });

    $('body').bind('click', function () {
      $('.ocar-months').removeClass('hover');
    });

    var $pre = $('#ocar-fees-container').closest('pre');
    $pre.before($('#ocar-fees-container').parent().html());
    $pre.remove();

    $('#ocar-fee-header').text($('#ocar-fee .ocar-show').attr('data-ocar-fee-header'));
    $('#ocar-key-header').text($('#ocar-key .ocar-show').attr('data-ocar-key-header'));
  });
};